import {WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import NamaPlace from "@/utils/presenters/NamaPlace.ts";
import {ref, Ref} from "vue";
import SearchingAndSuggestionUtil from "@/utils/editView/widgets/SearchingAndSuggestionUtil.ts";
import ListPlace from "@/utils/presenters/ListPlace.ts";
import TreeViewPresenter from "@/utils/presenters/TreeViewPresenter.ts";
import HierarchyFilterHelper from "@/utils/common/HierarchyFilterHelper.ts";
import TreeModelProvider from "@/utils/common/TreeModelProvider.ts";
import DTOCriteria = namaTypes.DTOCriteria;
import {EditPresenter} from "@/utils/presenters/EditPresenter.ts";

export default abstract class AbsPresenter implements WidgetsPresenter
{
  protected _entityType: string;
  protected record: Ref<Record<string, any>> = ref({});
  place?: NamaPlace;
  forSearch?: boolean;
  isBulkUpdating: boolean = false;

  protected constructor(place?: NamaPlace) {
    this._entityType = place instanceof ListPlace ? place.entityType! : "";
    this.place = place;
  }

  createSearchContextInfo(fieldId: string, lineNumber?: number): namaTypes.FieldActionContextInfo {
    return SearchingAndSuggestionUtil.createCommonSearchContextInfo(this.entityType, fieldId, lineNumber);
  }

  doesFieldHasSuggestionProvider(fieldMetaData: namaTypes.FieldMetaData): boolean {
    return false;
  }

  get entityType(): string {
    return this._entityType;
  }

  getDefaultCriteria(fieldId?: string): DTOCriteria | undefined {
    return undefined;
  }

  fetchNodeIdFromPlace(): string | undefined {
    return undefined;
  }

  setTreeView(treeViewPresenter: TreeViewPresenter): void {

  }

  onTreeNodeSelection(): void {
  }

  updateSelectedNodeId(value: string | undefined | null): void {

  }

  getHelperForTreeView(): HierarchyFilterHelper | undefined {
    return undefined;
  }

  getTreeModelProviderForTreeView(): TreeModelProvider | undefined {
    return undefined;
  }

  fetchColumnState(rowId: string, parentDetailId: string, columnId: string): string | undefined | null {
    return undefined;
  }

  fetchCriteriaFromPlace(): namaTypes.DTOCriteria | undefined {
    return undefined;
  }

  fetchDispatcher(): any {
    return undefined;
  }

  fetchExtraCriteriaIdFromPlace(): string | undefined {
    return undefined;
  }

  fetchParentFieldTitle(): string {
    return '';
  }

  fetchFieldErrorMsg(fieldId: string): string {
    return "";
  }

  fetchFieldState(fieldId: string): string | undefined | null {
    return undefined;
  }

  fetchMetadata(): namaTypes.NaMaMetaData {
    return {};
  }

  fetchPlace(): NamaPlace | undefined {
    return this.place;
  }

  fetchDefaultPageSize(): string | undefined {
    return undefined;
  }

  fetchQuestionFields(): namaTypes.QuestionField[] {
    return [];
  }

  fetchRecord(): Record<string, any> {
    return this.record.value;
  }

  isEditPresenter(): this is EditPresenter {
    return false;
  }

  isFieldDisabled(fieldId: string): boolean {
    return false;
  }

  isColumnDisabled(rowId: string, parentDetailId: string, columnId: string): boolean {
    return false;
  }

  isFieldHidden(field: string): boolean {
    return false;
  }

  isValidFieldForAttach(field: namaTypes.CompositeEditScreenField | namaTypes.EditScreenField | namaTypes.GUIActionPlaceholder): boolean {
    return false;
  }

  showApprovalDialog(entityType: string, entityId: string, nextStepName: string, concernedLines: string, nextStepSeq: number | undefined, fields: namaTypes.FieldMetaData[], summary: string | undefined): any {
  }

  fetchCriteriaFromFilterField(filteredType?: string): namaTypes.DTOCriteria | undefined {
    return;
  }
}
